import React, { useState } from 'react';
import { AppWrap } from '../../wrapper';
import PP from '../../assets/PP.pdf';
import './Work.scss';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

const dataCollection = [
  {
    question: <div><br></br><b>YOUR INFORMATION</b></div>,
    answer: <div> <br></br>When you purchase something from our website, as part of the buying and selling process, we collect the personal information you give us such as your name, address and email address.
    <br></br><br></br>When you browse our website, we also automatically receive your computer’s internet protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system.
    <br></br><br></br><b>Email marketing (if applicable)</b>: With your permission, we may send you emails about our website, new products and other updates.
    </div>
  },
  {
    question: <div><br></br><b>CONSENT</b></div>,
    answer: <div> <br></br><b>How do you get my consent?</b>
    <br></br><br></br>When you provide us with personal information to complete a transaction, verify your credit/debit card, place an order, arrange for a delivery or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only.
    <br></br><br></br>If we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no.
    <br></br><br></br><b>How do I withdraw my consent?</b>
    <br></br><br></br>If after you opt-in, you change your mind, you may withdraw your consent for us to contact you, for the continued collection, use or disclosure of your information, at anytime, by contacting us at <a href= "mailto:contact@munuandmoti.tech">contact@munuandmoti.tech</a> or mailing us at: B902, Antriksh Golf View 1, Sector 78, NOIDA, Uttar Pradesh - 201304, India.
    </div>
  },
  {
    question: <div><br></br><b>DISCLOSURE</b></div>,
    answer: <div> <br></br>We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.
    </div>
  },
  {
    question: <div><br></br><b>PAYMENT</b></div>,
    answer: <div> <br></br>We use Razorpay for processing payments. We/Razorpay do not store your card data on their servers. The data is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS) when processing payment. Your purchase transaction data is only used as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is not saved.
    <br></br><br></br>Our payment gateway adheres to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover.
    <br></br><br></br>PCI-DSS requirements help ensure the secure handling of credit card information by our website and its service providers.
    <br></br><br></br>For more insight, you may also want to read terms and conditions of Razorpay at <a href= "https://razorpay.com/terms/">https://razorpay.com/terms/</a>.
    <br></br><br></br>For international transfers, we also use Paypal for processing payments. We/Paypal do not store your card data on their servers. The data is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS) when processing payment. Your purchase transaction data is only used as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is not saved.
    <br></br><br></br>Our payment gateway adheres to the standards set by PCI-DSS as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa, MasterCard, American Express and Discover.
    <br></br><br></br>PCI-DSS requirements help ensure the secure handling of credit card information by our website and its service providers.
    <br></br><br></br>For more insight, you may also want to read terms and conditions of Paypal at <a href="https://www.paypal.com/in/webapps/mpp/ua/useragreement-full"> Paypal User Agreement - PayPal IN</a>.
    <br></br><br></br>For bank transfers, we use the services of HDFC Bank and all transfers are governed by the Terms and Conditions and Privacy Policy of HDFC Bank. . Your purchase transaction data is only used as long as is necessary to complete your purchase transaction. After that is complete, your purchase transaction information is not saved. We do not store your purchase data on our servers.
    <br></br><br></br>For more insight, you may want to read the terms and conditions of HDFC Bank at <a href="https://www.hdfcbank.com/personal/useful-links/terms-and-conditions">Terms & Conditions (hdfcbank.com)</a>, and their privacy policy at <a href="https://www.hdfcbank.com/personal/useful-links/privacy">Privacy (hdfcbank.com)</a>.
    </div>
  },
  {
    question: <div><br></br><b>THIRD-PARTY SERVICES</b></div>,
    answer: <div> <br></br>In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us.
    <br></br><br></br>However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions.
    <br></br><br></br>For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers.
    <br></br><br></br>In particular, remember that certain providers may be located in or have facilities that are located in a different jurisdiction than either you or us. So if you elect to proceed with a transaction that involves the services of a third-party service provider, then your information may become subject to the laws of the jurisdiction(s) in which that service provider or its facilities are located.
    <br></br><br></br>Once you leave our website or are redirected to a third-party website or application, you are no longer governed by this Privacy Policy or our website’s Terms of Service.
    <br></br><br></br><b>Links</b>: When you click on links on our website, they may direct you away from our site. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.
    </div>
  },
  {
    question: <div><br></br><b>SECURITY</b></div>,
    answer: <div> <br></br>To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed.
    </div>
  },
  {
    question: <div><br></br><b>COOKIES</b></div>,
    answer: <div> <br></br>We use cookies to maintain the session of your user. It is not used to personally identify you on other websites.
    </div>
  },
  {
    question: <div><br></br><b>AGE OF CONSENT</b></div>,
    answer: <div> <br></br>By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.
    </div>
  },
  {
    question: <div><br></br><b>CHANGES TO THIS PRIVACY POLICY</b></div>,
    answer: <div> <br></br>We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. MUNU & MOTI™ will alert you that changes or revisions have been made by indicating on the top of this Agreement the date it was last revised. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it. 
    <br></br><br></br>If our website is acquired or merged with another company, your information may be transferred to the new owners so that we may continue to sell products to you.
    </div>
  },
  {
    question: <div><br></br><b>QUESTIONS AND CONTACT INFORMATION</b></div>,
    answer: <div> <br></br>If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance Officer at <a href="mailto:compliance@munuandmoti.tech">compliance@munuandmoti.tech</a> or mailing us at: B902, Antriksh Golf View 1, Sector 78, NOIDA, Uttar Pradesh - 201304, India.
    <br></br><br></br>[Re: Privacy Compliance Officer]
    <br></br><br></br>[B902, Antriksh Golf View 1, Sector 78, NOIDA, Uttar Pradesh - 201304, India]
    </div>
  },
]

const DataAndPrivacy = () => {
  const [open, setOpen] = useState(false);
  const [accordion, setAccordion] = useState(-1);

  const toggleAccordion = (index) => {
    if(index === accordion)
    {
      setAccordion(-1);
      return;
    }
    setAccordion(index);
  }
  return (
    <>
     <h2 className='head-text'><span>Data</span> & <span>Privacy Policy</span></h2>
    <div>
      <div>
<div>
  <br></br><br></br>
  <p align="right"><i>LAST REVISION: [11 November 2022]</i></p>
  <br></br>
  <center><u>WHEN YOU USE OUR SERVICES, YOU’RE TRUSTING US WITH YOUR INFORMATION. WE UNDERSTAND THIS IS A BIG RESPONSIBILITY AND WORK HARD TO PROTECT OUR INFORMATION AND PUT YOU IN CONTROL. THIS PRIVACY POLICY IS MEANT TO HELP YOU UNDERSTAND WHAT INFORMATION WE COLLECT, WHY WE COLLECT IT, AND HOW YOU CAN UPDATE, MANAGE, EXPORT, AND DELETE YOUR INFORMATION.</u></center>
  <br></br><center><i>(Throughout the site, the terms “we”, “us” and “our” refer to  MUNU & MOTI™.)</i></center>
<br></br><br></br>
</div>
        <div className='accordion__faq'>
          {dataCollection.map((item, index)=>
          <div key={index} onClick={()=>toggleAccordion(index)}>
            <div className='accordion__faq-heading'>
            <h3 className={accordion === index ? "active" : ""}>{item.question}</h3>
            </div>
            <div>
              {accordion === index ? (<><span className='vertical'>
              <RemoveCircleOutlineIcon/>
            </span></>) : (<><span className='vertical'>
              <ControlPointIcon/>
            </span></>)}
            
            </div>
            <div>
              <p className={accordion === index ? "active" : "active not"}>{item.answer}</p>
            </div>

          </div>
          )}
        </div>
      </div>
    </div>
    <br></br>
      {/* <h2 className="head-text"><span>Data</span> & <span>Privacy</span> Policy</h2>
      <div className="app__work-portfolio">
      <iframe className='pdf' src={PP} />
      </div>  */}
    </>
  );
};

export default AppWrap( DataAndPrivacy, 'Data & Privacy' );
